module.exports = __webpack_public_path__ + "static/media/approval-flow.39e2a7fe.jpeg";